import {Component, OnInit, ViewChild} from "@angular/core";
import { ViewController, LoadingController, App, NavController, AlertController } from "ionic-angular";
import { CommonService } from "../../services/common.service";
import { Base64Util } from "../../util/base64Util";
import {AppDialog} from "../../component/appDialog";
import { UserService } from "../../services/user.services";
import {TabsPage} from "../tabs/tabs";
import { HomePage } from "../home/home";
import {LoginPage} from "../login/login";
import {AppConfig} from "../../util/appConfig";

@Component({
    templateUrl: 'headerSwitchAccount.html',
    selector: 'switch-account'
})

export class HeaderSwitchAccount implements OnInit{
    base64Util: any;

    constructor(public cs: CommonService, public userService: UserService,
                public app: App, public alertCtrl: AlertController, private loadingCtrl: LoadingController) {
        this.base64Util = new Base64Util();
    }

    ngOnInit() {

    }

    switchAccount() {
        let us = this.base64Util.decode(this.cs.username);
        let pass = this.base64Util.decode(this.cs.password);
        let TemU = localStorage.getItem("tu") !== null ? this.base64Util.decode(localStorage.getItem("tu")) : '';
        let TempP = localStorage.getItem("tp") !== null ? this.base64Util.decode(localStorage.getItem("tp")) : '';

        this.userService.loginOut(undefined, this).then(data => {
            this.cs.flagSwitch = true;
            if (data["msg"] == "") {
                if (TemU === us && TempP === pass) {
                    AppDialog.alert({
                        alertCtrl: this.alertCtrl,
                        message: 'Vui lòng đăng nhập lại tài khoản chính.',
                        callBack: () => {
                            this.app.getRootNav().setRoot(LoginPage);
                            this.cs.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                        }
                    });
                }else {
                    let user = {
                        un: us.toLowerCase(),
                        pwd: pass,
                        ver: AppConfig.Version
                    };
                    setTimeout( () => {
                    this.userService.login(user, this).then(data => {
                        this.cs.flagSwitch = false;
                        if (data["msg"] == "") {
                            this.cs.userType = data['user'].usertype;
                            this.app.getRootNav().push(TabsPage, {
                                paramUser: data["user"]
                            });
                        }else {
                            AppDialog.alert({
                                alertCtrl: this.alertCtrl,
                                message: data["msg"],
                                callBack: () => {
                                    this.app.getRootNav().setRoot(LoginPage);
                                    this.cs.userType = 0; // to hide top header 'Bạn đăng ở tài khoản chơi thử'
                                }
                            });
                        }
                    });
                }, 500);
                }
            } else {
                AppDialog.alert({
                    alertCtrl: this.alertCtrl,
                    message: data["msg"]
                });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/headerSwitchAccount/headerSwitchAccount.ts